import React, { useEffect } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useState } from "react";
import DataTable from "react-data-table-component";
import { dataTableCustomStyles } from "../../../common/datatable/styles";
import { useMemo } from "react";
import FilterComponent from "../../../ui/filter";
import ItemsListByBrandId from "../brands-details/items-list";
import { DeleteBrandByIdAsync } from "../service/BrandService";
import { GetBrandsAsync } from "../service/BrandService";
import { GetBrandViewModel } from "../../../common/brand.services/helperService";
import { GetBrandsPagedAsync } from "../service/BrandService";
import * as AiIcons from "react-icons/ai";
import { toast } from "react-toastify";

export default function BrandsList() {
  const [loading, setLoading] = useState(false);
  const [brandsView, setBrandsView] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowToRemovePriceGroup, setRowToRemovePriceGroup] = useState(-1);
  const [filterNameText, setFilterNameText] = useState("");
  const [filterOwnerNameText, setFilterOwnerNameText] = useState("");
  const filteredBrands = getFilteredItems();
  function getFilteredItems() {
    return brandsView.filter((item) => {
      const lowerCaseName = item.brand?.toLowerCase() || "";
      const lowerCaseOwnerName = item.name?.toLowerCase() || "";

      return (
        lowerCaseName.includes(filterNameText.toLowerCase()) &&
        lowerCaseOwnerName.includes(filterOwnerNameText.toLowerCase())
      );
    });
  }

  useEffect(() => {
    // Clear any existing timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const newTimeout = setTimeout(() => {
      let nameFilter = filterNameText !== "" ? filterNameText : "";
      let ownerNameFilter =
        filterOwnerNameText !== "" ? filterOwnerNameText : "";

      fetchBrands(page, pageSize, nameFilter, ownerNameFilter);
    }, 1000);

    setTypingTimeout(newTimeout);
  }, [filterNameText, filterOwnerNameText]);

  const getBrandsPaged = async (page, pageSize, nameFilter, ownerNameFilter) => {
    let response = await GetBrandsPagedAsync(
      page,
      pageSize, 
      nameFilter,
      ownerNameFilter,
    );
    return response.data;
  };

  const fetchBrands = async (
    page,
    pageSize,
    ownerNameFilter,
    nameFilter
  ) => {
    try {
      setLoading(true);
      const response = await getBrandsPaged(
        page,
        pageSize,
        nameFilter,
        ownerNameFilter
      );

      setBrandsView([
        ...response.items.map((item) => {
          return GetBrandViewModel(item);
        }),
      ]);
      setTotalRows(response.meta.totalCount);
    } catch (error) {
      toast.error(error.message);
      console.log(error);
    }
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchBrands(page, pageSize, filterNameText, filterOwnerNameText);
    setPage(page);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    fetchBrands(page, newPerPage, filterNameText, filterOwnerNameText);
    setPage(page);
    setPageSize(newPerPage);
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        fetchBrands(page, pageSize, filterNameText, filterOwnerNameText);
      } catch (error) {
        toast.error(error.message);
        console.log(error);
      }
      setLoading(false);
    })();
  }, []);

  const subHeaderComponentMemo = useMemo(() => {
    const handleNameClear = () => {
      if (filterNameText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterNameText("");
      }
    };
    const handleOwnerNameClear = () => {
      if (filterOwnerNameText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterOwnerNameText("");
      }
    };

    

    return (
      <div className="filter-header">
        <FilterComponent
          onFilter={(e) => setFilterNameText(e.target.value)}
          onClear={handleNameClear}
          filterText={filterNameText}
        />
        <FilterComponent
          placeholder="filter by owner name"
          onFilter={(e) => setFilterOwnerNameText(e.target.value)}
          onClear={handleOwnerNameClear}
          filterText={filterOwnerNameText}
        />
      </div>
    );
  }, [filterNameText, filterOwnerNameText, resetPaginationToggle]);



  const brandsTableColums = [
    {
      name: "Id",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Brand", // Price group name
      selector: (row) => row?.brand,
      sortable: true,
    },
    {
      name: "Owner", // Owner name
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "AccessDefault", // Price group default percent
      selector: (row) => `${row?.accessDefault}`,
      sortable: true,
    },
    {
      name: "Dropship is available", // Price group default reference
      selector: (row) => row?.dropshipAvailable?.toString(),
      sortable: true,
    },

    {
      name: "Edit",
      button: true,
      cell: (row) => (
        <div className="actions">
          <Link to={`${row.id}/edit`}>
            <Button
              style={{
                width: "4vw",
              }}
              variant="light"
            >
              Edit
            </Button>
          </Link>
        </div>
      ),
    },
    {
      name: "Remove",
      button: true,
      cell: (row) =>
        rowToRemovePriceGroup !== row.id ? (
          <Button
            onClick={() => ConfidenceToRemovePriceGroup(row.id)}
            style={{ width: "5vw" }}
            variant="light"
          >
            Remove
          </Button>
        ) : (
          <div className="delete-container">
            <Button
              variant="light"
              style={{ width: "2vw", marginRight: "3px" }}
              onClick={() => RemoveBrand(rowToRemovePriceGroup)}
            >
              <AiIcons.AiOutlineCheck></AiIcons.AiOutlineCheck>
            </Button>
            <Button
              onClick={NotSureToRemovePriceGroup}
              variant="light"
              style={{ width: "2.5vw", alignItems: "center" }}
            >
              <AiIcons.AiOutlineClose></AiIcons.AiOutlineClose>
            </Button>
          </div>
        ),
    },
  ];

  async function RemoveBrand(id) {
    try {
      let response = await DeleteBrandByIdAsync(id);
      if (response.status == 200) {
        toast.success(`Price Group with id: ${id} successfully removed!`);
        fetchBrands(page, pageSize, filterNameText);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.details);
      } else {
        toast.error("Bad interent connection");
      }
    }

    fetchBrands(page, pageSize, filterNameText, filterOwnerNameText);
    setRowToRemovePriceGroup(-1);
  }
  function NotSureToRemovePriceGroup() {
    setRowToRemovePriceGroup(-1);
  }
  function ConfidenceToRemovePriceGroup(id) {
    setRowToRemovePriceGroup(id);
  }

  return (
    <div className="items-list">
      <div className="toolBar">
        <Link to={"new"}>
          <Button className="action-button" variant="light" disabled="true">
            Create
          </Button>
        </Link>
      </div>

      <DataTable
        progressPending={loading}
        paginationServer
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        paginationResetDefaultPage={resetPaginationToggle}
        persistTableHead
        customStyles={dataTableCustomStyles}
        title="Brands"
        columns={brandsTableColums}
        data={filteredBrands}
        pagination
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      ></DataTable>
    </div>
  );
}